import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import * as React from 'react';

import { ContextStore } from 'bernie-core';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { getPropertyOffersInput } from 'stores/adapters/bex-api/property-info/property-info-input-adapter';
import { MultiItemStore } from 'stores/multi-item-store';

import { PropertyInfoOffersBexFeatures } from 'src/common/__generated__/api';

export interface SharedUiPropertyOffersComponentProps {
  currentHotel?: CurrentHotelStore;
  multiItem?: MultiItemStore;
  context?: ContextStore;
}

export interface SharedUiWrapperProps {
  inputs?: PropertyInfoOffersBexFeatures.Variables;
  data?: any;
}

export const withSharedUiPropertyOffers = <F extends {}>(SharedUiWrapper: React.FC<SharedUiWrapperProps>) => {
  const PropertyOffersComponent: React.FC<F & SharedUiPropertyOffersComponentProps> = inject(
    'currentHotel',
    'context',
    'multiItem'
  )(
    observer(({ currentHotel, context, multiItem, ...props }) => {
      if (!currentHotel || !currentHotel.searchCriteria) {
        return null;
      }

      const inputs = getPropertyOffersInput(context, currentHotel, multiItem?.multiItemContext);

      const propertyInfoOffersResponse = toJS(currentHotel?.bexApiPropertyInfoOffersResponse);
      const propertyReviewAggregatesResponse = toJS(currentHotel?.sharedUiPropertyReviewAggregatesResponse);
      const amenitiesResponse = toJS(currentHotel?.sharedUiAmenitiesResponse);

      if (!propertyInfoOffersResponse) {
        return null;
      }

      // Build the data structure needed for offers components.
      // Remove it once the shared-ui components can query themselves.
      const data = {
        propertyInfo: {
          ...propertyInfoOffersResponse,
          summary: {
            amenities: amenitiesResponse,
          },
        },
        propertyReviewAggregates: propertyReviewAggregatesResponse,
      };

      return <SharedUiWrapper inputs={inputs} data={data} {...props} />;
    })
  );
  PropertyOffersComponent.displayName = 'PropertyOffersComponent';

  return PropertyOffersComponent;
};
